import { render, staticRenderFns } from "./Addons.vue?vue&type=template&id=5d45677c&"
import script from "./Addons.vue?vue&type=script&lang=js&"
export * from "./Addons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d45677c')) {
      api.createRecord('5d45677c', component.options)
    } else {
      api.reload('5d45677c', component.options)
    }
    module.hot.accept("./Addons.vue?vue&type=template&id=5d45677c&", function () {
      api.rerender('5d45677c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/Addons.vue"
export default component.exports